import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Menu,
  Button,
  Segment
} from 'semantic-ui-react';

import { getIsActiveAndNotExpiredLicensePool } from '_utils/licensePools';

import CreateNewKeyForm from '_forms/institutionKeyForm';

import Key from './key';
import useCanAdminInstitution from '../../hooks/useCanAdminInstitution';

// const mapKeySources = (acsources, licenses) => R.map(
//   ({text, value}) => {
//     const disabled = value === 'subscription'
//       ? !R.both(
//         R.pathSatisfies(x => x > 0, [value, 'key']),
//         R.pathSatisfies(date => new Date(date) > new Date(), [value, 'expires_on'])
//       )(licenses)
//       : !R.pathSatisfies(x => x > 0, [value, 'key'], licenses)

//     return {text, value, disabled}
//   },
//   acsources
// )

const KeyList = ({
  institution,
  onAddKey,
  onRemoveKey,
  onRemoveKeyMachine
}) => {

  const canAdminKeys = useCanAdminInstitution(institution);
  const [showNewKeyForm, setShowNewKeyForm] = useState(false);
  const [newKeyFormData, setNewKeyFormData] = useState({
    license_pool_id: null,
    session_length_min: 60,
    description: ''
  });

  const onNewKeyFormChange = (name, value) => setNewKeyFormData(Object.assign({}, newKeyFormData, { [name]: value }));
  const onCreateNewKey = (e) => {
    e.preventDefault();
    if (onAddKey) {
      onAddKey({
        institutionId: institution._id,
        payload: newKeyFormData
      });
      setShowNewKeyForm(false);
    }
  };

  const onShowNewKeyForm = () => setShowNewKeyForm(true);
  const onHideNewKeyForm = () => setShowNewKeyForm(false);

  const canCreateKeys = institution.license_pools.filter(p => getIsActiveAndNotExpiredLicensePool(p)).length > 0;

  const onRemoveInstKey = (keyId) => {
    onRemoveKey({ institutionId: institution._id, keyId });
  };
  const onRemoveInstKeyMachine = (args) => {
    onRemoveKeyMachine(Object.assign({}, args, { institutionId: institution._id }));
  };

  return (
    <Container fluid>
      <Menu size='mini'>
        {
          canAdminKeys ? (
            <Menu.Menu position='left'>
              <Menu.Item>
                <Button onClick={ onShowNewKeyForm } disabled={ showNewKeyForm || !canCreateKeys } icon='key' content='Create Key' />
              </Menu.Item>
            </Menu.Menu>
          ) : null
        }
      </Menu>

      <Segment.Group>
        {
          showNewKeyForm ? (
            <Segment>
              <CreateNewKeyForm
                data={ newKeyFormData }
                institution={ institution }
                onChange={ onNewKeyFormChange }
                onCancel={ onHideNewKeyForm }
                onSubmit={ onCreateNewKey }
              />
            </Segment>
          ) : null
        }
        {
          !showNewKeyForm ? (institution.keys || []).map(clave => (
            <Key
              key={ clave._id }
              clave={ clave }
              onRemoveKey={ onRemoveInstKey }
              onRemoveKeyMachine={ onRemoveInstKeyMachine }
            />
          )) : null
        }
      </Segment.Group>
    </Container>
  );
}

KeyList.propTypes = {
  institution: PropTypes.object.isRequired,
  onAddKey: PropTypes.func.isRequired,
  onRemoveKey: PropTypes.func.isRequired,
  onRemoveKeyMachine: PropTypes.func.isRequired
};

export default KeyList;



// WEBPACK FOOTER //
// ./webAdmin/views/keys/index.js